module.exports = __webpack_public_path__ + "static/media/Delphox_gaussian2.d718dbd0.png";